
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apidocs",
      function () {
        return require("private-next-pages/apidocs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apidocs"])
      });
    }
  